import React, {Component} from 'react';

export const GlobalContext = React.createContext();

export class GlobalContextProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCategoriesListVisible: false,
            setCategoriesListVisibility: (isVisible) => {
                this.setState({isCategoriesListVisible: isVisible});
            }
        }
    }

    render() {
        return (
            <GlobalContext.Provider value={this.state}>
                {this.props.children}
            </GlobalContext.Provider>
        )
    }
}